var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "gp2-research-modal",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
          },
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.$emit("close")
            },
          },
        },
        [
          _c("div", { staticClass: "gp2-research-panel" }, [
            _c("header", { staticClass: "gp2-research-head" }, [
              _c("h2", { attrs: { id: _vm.titleId } }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _c(
                "button",
                {
                  staticClass: "gp2-research-close",
                  attrs: { type: "button", "aria-label": `Close ${_vm.title}` },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
            ]),
            _c("div", { staticClass: "gp2-research-body" }),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }